module.exports = __webpack_public_path__ + "resources/img/logo_tcc.50c3192e1d90d0c9615bf532a5318cb4.png";